import React, { useState, useEffect, createContext, useContext } from 'react';

const TabsContext = createContext();

export const Tabs = ({ value, defaultValue, onValueChange, className = '', children, ...props }) => {
  const [activeTab, setActiveTab] = useState(value ?? defaultValue);

  // Support controlled usage: if value prop changes, sync state
  useEffect(() => {
    if (value !== undefined) {
      setActiveTab(value);
    }
  }, [value]);
  
  const handleTabChange = (newValue) => {
    setActiveTab(newValue);
    if (onValueChange) {
      onValueChange(newValue);
    }
  };
  
  return (
    <TabsContext.Provider value={{ activeTab, setActiveTab: handleTabChange }}>
      <div className={`${className}`} {...props}>
        {children}
      </div>
    </TabsContext.Provider>
  );
};

export const TabsList = ({ className = '', children, ...props }) => {
  const listClass = `nav nav-tabs ${className || 'nav-tabs-v2'}`.trim();
  return (
    <ul className={listClass} role="tablist" {...props}>
      {children}
    </ul>
  );
};

export const TabsTrigger = ({ value, className = '', children, ...props }) => {
  const { activeTab, setActiveTab } = useContext(TabsContext);
  const isActive = activeTab === value;
  
  return (
    <li className="nav-item" role="presentation">
      <button
        type="button"
        className={`nav-link d-inline-flex align-items-center gap-2 me-2 ${isActive ? 'active' : ''} ${className}`}
        onClick={() => setActiveTab(value)}
        role="tab"
        aria-selected={isActive}
        aria-current={isActive ? 'page' : undefined}
        {...props}
      >
        {children}
      </button>
    </li>
  );
};

export const TabsContent = ({ value, className = '', children, ...props }) => {
  const { activeTab } = useContext(TabsContext);
  const isActive = activeTab === value;
  
  if (!isActive) return null;
  
  return (
    <div className={`tab-pane fade show active ${className}`} role="tabpanel" {...props}>
      {children}
    </div>
  );
};